import { App } from "vue";
import posthog, { PostHog } from "posthog-js";

export default {
  install(app: App) {
    const posthogInstance = posthog.init(
      process.env.VUE_APP_POSTHOG_CLIENT_KEY,
      {
        api_host: "https://us.i.posthog.com",
        person_profiles: "identified_only",
      }
    ) as PostHog;

    if (posthogInstance) {
      app.config.globalProperties.$posthog = posthogInstance;
    } else {
      console.error("PostHog initialization failed.");
    }
  },
};
